var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',[(_vm.currentPage !== 'landing')?_c('Nav'):_vm._e()],1),_c('div',{staticClass:"content"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }